export function getTemplateButtons(template) {
  return template?.components?.find((component) => component?.type === 'BUTTONS')?.buttons ?? [];
}

export function getButtonDisplayLabel(button, index) {
  const label = (button?.text || button?.name || '').trim();
  return label || `Button ${index + 1}`;
}

/** @returns {{ accessorKey: string, label: string }[]} */
export function getTemplateButtonColumnDefs(template) {
  return getTemplateButtons(template).map((button, index) => ({
    accessorKey: `button_count_${index + 1}`,
    label: getButtonDisplayLabel(button, index),
  }));
}
